import { z } from 'zod'
import { makeFieldKeys, validateWithZodSchema } from '../../core/utils/utilities.ts'

export const ShareRegisterModelSchema = z
  .object({
    id: z.string(),
    label: z.string()
  })
  .strict()

const ShareRegisterModelFields = makeFieldKeys(ShareRegisterModelSchema)

export type ShareRegisterModel = z.infer<typeof ShareRegisterModelSchema>

function validateShareRegisterModel(data: unknown): ShareRegisterModel {
  try {
    return validateWithZodSchema(ShareRegisterModelSchema, data, 'share register model')
  } catch (error) {
    throw new Error(`Share register model validation failed: ${error}`)
  }
}
